import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

interface Benefit {
  number: string;
  title: string;
  description: string;
}

const WhyChoose: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const benefits: Benefit[] = [
    {
      number: '100%',
      title: 'Data Ownership',
      description: "Complete control over your organization's communications and data",
    },
    {
      number: '24/7',
      title: 'AI Assistant',
      description: 'Instant answers and automated actions powered by intelligent AI',
    },
    {
      number: '0',
      title: 'Language Barriers',
      description: 'Real-time translation and correction across all communications',
    },
    {
      number: '∞',
      title: 'Scalability',
      description: 'From small teams to global enterprises, SoEz grows with you',
    },
  ];

  return (
    <section id="why-choose" className="bg-gradient-to-br from-soez-blue to-soez-blue-dark text-white py-20 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Why Organizations Choose SoEz</h2>
          <div className="w-20 h-1 bg-soez-orange mx-auto mb-6" />
          <p className="text-xl opacity-95 max-w-2xl mx-auto">
            Built for enterprises that refuse to compromise on security, intelligence, or efficiency.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`text-center p-8 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="text-6xl font-bold text-soez-orange mb-2">{benefit.number}</div>
              <h4 className="text-xl font-semibold mb-2">{benefit.title}</h4>
              <p className="opacity-90 text-sm">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
